// @ts-nocheck
import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { PharmacyAnnualReview } from './models/PharmacyAnnualReview';
import NotificationToast from '../components/common/NotificationToast';

export const PharmacyAnnualReviewSearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  year: types.maybeNull(types.number),
  validated: types.maybeNull(types.boolean),
  status: types.maybeNull(types.string),
  level: types.maybeNull(types.number),
});

export const PharmacyAnnualReviewStore = types
  .compose(
    getBaseStore<Instance<typeof PharmacyAnnualReview>, Instance<typeof PharmacyAnnualReview>>(
      PharmacyAnnualReview,
      'pharmacyAnnualReviewId',
      'pharmacyAnnualReview',
    ),
    types.model('PharmacyAnnualReviewStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const validateReview = flow(function*(pharmacyAnnualReview: Instance<typeof PharmacyAnnualReview>) {
      yield env.api.post('pharmacyAnnualReview/Validate', pharmacyAnnualReview);
      NotificationToast.showSuccess('Data validate successfully');
    });

    const updateReviewInStore = (pharmacyAnnualReview: Instance<typeof PharmacyAnnualReview>) => {
      const pharmacyAnnualReviewModel = PharmacyAnnualReview.create(pharmacyAnnualReview);
      self.datas.put(pharmacyAnnualReviewModel);
      return pharmacyAnnualReviewModel;
    };

    const search = flow(function*(criteria: Instance<typeof PharmacyAnnualReviewSearchCriteria>) {
      const result = yield apiFetcher.get('pharmacyAnnualReview', {
        params: criteria,
      });
      const resultReview: Array<Instance<typeof PharmacyAnnualReview>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdReview = updateReviewInStore(node);
        resultReview.push(createdReview);
      });
      return resultReview;
    });

    const generateAnnualReview = flow(function*(secretariatId: number, year: number) {
      yield env.api.post('pharmacyAnnualReview/GenerateAnnualReviews/' + year + '/' + secretariatId, null);
    });

    return { search, validateReview, generateAnnualReview };
  });

export type PharmacyAnnualReviewStoreType = Instance<typeof PharmacyAnnualReviewStore>;
